import { useBreakpoint } from './useBreakpoint'

// Сенсорный экран боком: высоты мало, поэтому навигация уезжает в боковое меню.
// Условие повторяет $touch-landscape из styles/_breakpoints.scss
export const useIsTouchLandscape = (): boolean => useBreakpoint().isTouchLandscape
